import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SARConfiguration } from 'dashboard/models/sar-configuration';
import { setSARConfiguration } from 'dashboard/redux/slices/sar-configuration';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint } from 'lib/interfaces/api';

export function loadSARConfiguration(organizationId: string): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const { data } = await SessionClientDashboard.getResource<SARConfiguration>(
      ApiEndpoint.SARConfiguration,
      organizationId,
    );

    dispatch(setSARConfiguration(data));
  };
}
